export const convertToPercentage = (value, maxValue) => {
  return (100 * value) / maxValue + '%';
};

export const currencyToSymbol = {
  EUR: '€',
  USD: '$',
  GBP: '£',
  RON: 'Lei',
};

export const localeToCurrency = {
  lt: 'EUR',
  ro: 'RON',
};

export const getSiteCurrency = () => {
  let currency = null;
  if (process.env.GATSBY_DEFAULT_LANGUAGE) {
    currency = localeToCurrency[process.env.GATSBY_DEFAULT_LANGUAGE];
  }
  return currency;
};

export const toFixed2 = (value) => {
  const result = Number(value).toFixed(2);

  if (Number.isNaN(result)) {
    return undefined;
  }

  return result;
};
